import React, { Component } from 'react'
import { Alert } from 'reactstrap'

import { auth } from '../../firebase'
import * as routes from '../../constants/routes'
import * as layout from '../../constants/layout'
import Icon from '../Icon'

import { DivWithMargin, FillerDiv } from '../StyledComponents/Fillers'
import { SignInFormular, SignUpLink as Link } from '../StyledComponents/Authentication'

const PasswordForgetPage = () =>
    (
        <FillerDiv>
            <PasswordForgetForm />
        </FillerDiv>
    )

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
})

const INITIAL_STATE = {
    email: '',
    error: null,
}

class PasswordForgetForm extends Component {
    constructor(props) {
        super(props)

        this.state = { ...INITIAL_STATE }
    }

    onSubmit = (event) => {
        const { email } = this.state

        auth.doPasswordReset(email)
            .then(() => {
                this.setState(() => ({ ...INITIAL_STATE }))
            })
            .catch((error) => {
                this.setState(byPropKey('error', error))
            })

        event.preventDefault()
    }

    render() {
        const {
            email,
            error,
        } = this.state

        const isInvalid = email === ''

        return (
            <SignInFormular className="text-center" onSubmit={this.onSubmit}>
                <Icon />
                <h1 className="h3 mb-3 font-weight-normal">Passwort vergessen?</h1>

                <DivWithMargin top="10" bottom="10">
                    <label htmlFor="inputEmail" className="sr-only">Email Adresse</label>
                    <input
                        value={this.state.email}
                        onChange={event => this.setState(byPropKey('email', event.target.value))}
                        type="email"
                        id="inputEmail"
                        className="form-control"
                        placeholder="Email Adresse"
                        required
                    />
                </DivWithMargin>

                <button className="btn btn-lg btn-primary btn-block" disabled={isInvalid} type="submit">
                    Passwort zurücksetzen
                </button>

                { error && <DivWithMargin top={layout.MARGIN_TOP} bottom={layout.MARGIN_BOTTOM}><Alert color="danger">{error.message}</Alert></DivWithMargin> }
            </SignInFormular>
        )
    }
}

const PasswordForgetLink = () => <Link to={routes.PASSWORD_FORGET}>Passwort zurücksetzen</Link>

export default PasswordForgetPage

export {
    PasswordForgetForm,
    PasswordForgetLink
}



// WEBPACK FOOTER //
// ./src/components/userManagement/PasswordForget.js